module.exports = __webpack_public_path__ + "img/KSC08915.cb68024d.jpg";